export default __webpack_public_path__ + "static/businessday-c487b9ca31d0a7d6bc6ce06492e321db.png";